import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetProductTypeSlice = createSlice({
    name: "getProductType",
    initialState,
    reducers: {
        getProductTypeRequest(state) {
            state.loading = true;
        },
        getProductTypeRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getProductTypeRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getProductTypeRequest,
    getProductTypeRequestSuccess,
    getProductTypeRequestError,
} = GetProductTypeSlice.actions;

export default GetProductTypeSlice.reducer;
